export const meta = {
  alias: 'website-translator',
  name: 'Website Translator'
};
